import { makeAutoObservable } from 'mobx';

import http from '../helpers/http';

import User from './models/User';

export default class UserStore {
    constructor() {
        makeAutoObservable(this);
    }

    static async find(role: string) {
        const { data } = await http.get(`/users?filters[where][role]=${role}&size=10`);
        return (data.users.map((user: any) => new User().fromJSON(user)) as User[]);
    }

    static async findById(id: string) {
        const { data } = await http.get(`/users/${id}`);
        return new User().fromJSON(data);
    }

    static async saveById(id: string, formData: any) {
        const { data } = await http.put(`/users/${id}`, formData);
        return new User().fromJSON(data);
    }

    static async deleteById(id: string) {
        await http.delete(`/users/${id}`);
    }
}
